import { Button } from '@/components/ui';
import TooltipWrapper from '@/components/ui/tooltip';
import { CloseDialog } from '@/features/trade/order/components/close-dialog';
import {
  getMigrationBlockTooltipKey,
  useMigrationTradingBlock,
} from '@/hooks/use-migration';
import { useMarketStore } from '@/store/use-markets-store';
import { MarketStatus } from '@/types';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';

type Props = {
  symbol: string;
};

export default function Close({ symbol }: Props) {
  const { t } = useTranslation();

  const isHalt = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.status === MarketStatus.HALT,
  );
  const { isBlocked: isMigrationBlocked, reason: migrationReason } =
    useMigrationTradingBlock();

  if (isHalt || isMigrationBlocked) {
    return (
      <TooltipWrapper
        content={
          isMigrationBlocked
            ? t(getMigrationBlockTooltipKey(migrationReason))
            : t('positionsTable.marketClosed')
        }
        direction="bottom"
        portal
      >
        <Button disabled variant="outline" size="lg">
          {t('positionsTable.close')}
        </Button>
      </TooltipWrapper>
    );
  }

  return <CloseDialog symbol={symbol} />;
}
